// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { consumeHandoffCookie } from './utils/handoff'
import Lang from 'vue-lang'
import languages from './languages'
import moment from 'moment'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VeeValidate from 'vee-validate'
import VeeValidateConfig from './config/veeValidate'
import ToastrInstaller from './components/UI/toastr/Toastr'
import './shared/mixins'
import VueTypeaheadBootstrap from '@/components/vue-typeahead-bootstrap/VueTypeaheadBootstrap'
import money from 'v-money'
import Vue2Editor from 'vue2-editor'
import TagsInput from '@voerro/vue-tagsinput'
import '@voerro/vue-tagsinput/dist/style.css'
import 'ag-grid-enterprise'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

if (process.env.NODE_ENV !== 'development') {
  require('../scss/style.scss')
  require('../scss/clients/zopone.scss')
}

const lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'ptBr'

Vue.use(Lang, { lang: lang, locales: languages })
Vue.prototype.moment = moment
Vue.use(BootstrapVue)
Vue.use(Vue2Editor)
Vue.use(VeeValidate, VeeValidateConfig)
ToastrInstaller.Install()
Vue.component('v-select', vSelect)
Vue.component('autocomplete', VueTypeaheadBootstrap)
Vue.component('tags-input', TagsInput)
Vue.use(money, {precision: 4})
Vue.use('multiselect', Multiselect)

// Vue.use(vueConfig, configs)
// const API = this.$config.API

// --- Handoff de empresa entre abas ---
// Se esta aba foi aberta a partir de outra (via link ou window.open),
// o cookie empresa_handoff estará presente. Lemos, jogamos no sessionStorage
// e deletamos o cookie antes de qualquer componente montar.
const handoffValue = consumeHandoffCookie()
if (handoffValue) {
  store.commit('company/setCompany', JSON.parse(handoffValue))
}
// ------------------------------------

/* eslint-disable no-new */
// Prod/aceite: verificar sessão ativa (cookie → /me) antes de montar — popula userIsLoggedIn
// Dev: Vue monta direto — guards usam JWTService.GetToken() do localStorage
// Exceção: na rota /sso/... ainda não há cookie (o token ainda vai ser trocado pelo backend).
// Pular a verificação de sessão no boot evita um 401 inútil e o efeito colateral do interceptor.
const isSSOEntry = window.location.pathname.startsWith('/sso/')

if (process.env.NODE_ENV !== 'development' && !isSSOEntry) {
  store.dispatch('auth/fetchUserInfo').finally(() => {
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
  })
} else {
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
}



// WEBPACK FOOTER //
// ./src/main.js